import React from "react";
import PropTypes from "prop-types";
import {
  SnailIcon as Normal,
  SnailHighlightedIcon as Highlighted,
} from "../../Icons";
import { Image } from "@learningblocks/shared-components";
import { SnailTooltip } from "./SnailTooltip";
import className from "./style.module.scss";

export function Snail({ rotate }) {
  const [hover, setHover] = React.useState(false);

  const setImage = () => (hover ? Highlighted : Normal);

  const toggleHover = (value) => () => setHover(value);

  const setStyle = () => {
    return { transform: `rotate(${rotate}deg)` };
  };

  return (
    <div
      className={className.snail}
      onMouseEnter={toggleHover(true)}
      onMouseLeave={toggleHover(false)}
    >
      <SnailTooltip selected={hover} />
      <Image
        className={className.image}
        style={setStyle()}
        src={setImage()}
        alt="snail-icon"
      />
    </div>
  );
}

Snail.propTypes = {
  /**
   * transform rotate value for object
   */
  rotate: PropTypes.number,
};

Snail.defaultProps = {
  rotate: 0,
};
